export default (props) => Number(props.match.params.id);
